/* eslint-disable no-unused-vars */
export enum HealthSummaryQuestionMapping {
  consultWay='Hooray - last question!  How would you like to do your telehealth consult?',
  howHear='How did you hear about us?',
  cover='What cover do you have?',
  gpName='Referring doctor and clinic',
  healthConcern='What would you like help with?',
  allergies='Allergies',
  currentMedication='Current medication',
}
